import React from 'react';
// @ts-expect-error File is present
import content from '../../content/privacy-policy.md';
import '@fontsource/nunito/400.css';
import C from './PrivacyPage.css';

export default function PrivacyPage() {
  return (
    <div className={C.pageContainer}>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
}
